import { Controller } from "@hotwired/stimulus"

// The "Clear all" / "Clear" / "Clear filters" links reset the search by
// navigating (via turbo_stream) to videos_path. That response re-renders the
// results and facets, but deliberately NOT the search input — the stream never
// re-renders it, so live typing isn't clobbered mid-keystroke. The upshot is the
// input keeps its old value and reappears, populated, when the modal is reopened.
//
// Clear it here in step with the link's reset: empty the global #query input and
// hide its (modal) clear button. The link's own server navigation handles the
// rest. Mirrors mobile_search_clear_controller, minus the resubmit (the link
// already does that).
export default class extends Controller {
  clear() {
    const results = document.getElementById('search_results')
    results?.classList.add('is-search-pending')
    results?.setAttribute('aria-busy', 'true')

    const query = document.getElementById("query")
    if (query) query.value = ""

    document
      .querySelectorAll('[data-search-target="clearButton"]')
      .forEach((button) => button.classList.add("hidden"))
  }
}
